import { DatastoreProvider, InstanceStack } from 'component/navigation/instance';
import { useInstanceConfig } from 'data/instance-config';
import { useLocalSearchParams } from 'expo-router';
import { getIsInSidebar } from 'platform-specific/url';
import { SkeletonSidebarProfileScreen, SkeletonStandaloneProfileScreen } from 'structure/profile/loading-screen';
import { profileModuleQuery } from 'system/structure-modules';

export function SuspenseFallback() {
    return <ProfileLoadingScreen />;
}

export default function ProfileInstanceLayout() {
    const { siloKey, instanceKey } = useLocalSearchParams<'/[siloKey]/profile/[instanceKey]'>();
    const instanceConfig = useInstanceConfig({
        siloKey,
        structureKey: 'profile',
        instanceKey,
        moduleQuery: profileModuleQuery,
    });
    return (
        <DatastoreProvider {...instanceConfig}>
            <InstanceStack />
        </DatastoreProvider>
    );
}

function ProfileLoadingScreen() {
    if (getIsInSidebar()) {
        return <SkeletonSidebarProfileScreen />;
    }

    return <SkeletonStandaloneProfileScreen />;
}
